module.exports = __webpack_public_path__ + "static/media/6.4 Blumenstillleben OfR klein.1218e4d2.jpg";